import styled from 'styled-components/macro'

export const PageWrapper = styled.div`
  min-width: 320px;
  margin-top: ${({ isFullScreen }) => (isFullScreen ? '0' : 'var(--page-wrapper-offset)')};
  width: 100vw;
  max-width: 100%;
  height: ${({ isFullScreen }) => (isFullScreen ? '100vh' : 'unset')};
`
